import { Avatar } from '@/components/atoms';

interface AvatarWithNameProps {
	src: string;
	alt: string;
	firstName: string;
	lastName: string;
	avatarSize?: number;
	className?: string;
}

export const AvatarWithName = ({ src, alt, firstName, lastName, avatarSize = 36, className = '' }: AvatarWithNameProps) => {
	return (
		<div className={`flex items-center ${className}`}>
			<Avatar src={src} alt={alt} width={avatarSize} height={avatarSize} />
			<p className="pl-4 text-2xl font-medium leading-[32px]">
				{firstName} {lastName}
			</p>
		</div>
	);
};
